import { trigger, animate, style, group, animateChild, query, stagger, transition, state } from '@angular/animations';

export const alertTransition = trigger('alertTransition', [
    state('in', style({ transform: 'translateX(0)' })),
    transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('.2s ease-out')
    ]),
    transition(':leave', [
        animate('.15s ease-in-out', style({ transform: 'translateX(100%)' }))
    ])
]);
